import { Company } from './company';
import { Base } from './base';
import { ParkingPoint, IParkingPoint } from './parking-point';

export class Parking extends Base {
    ParkingID?: number;
    ParkingTypeID?: number;
    ParkingLevelID?: number;
    AuthorID?: string;
    OwnerID?: string;
    CompanyID?: number;
    AddressID?: string;
    PublicInstitutionID?: number;
    Title: string;
    Phone?: string;
    Email?: string;
    CreateDate?: Date;
    EntranceLatitude?: number;
    EntranceLongitude?: number;
    Description?: string;
    NoLots?: number;
    DefaultDuration?: number;
    Color?: string;
    Subtitle?: string;

    // Navigation properties
    Company?: Company;
    ParkingPoints?: Array<ParkingPoint>;

    // Model properties
    ModelAuthor?: string;
    ModelAddress?: string;
    ModelCompany?: string;
    ModelContactPerson?: string;
    ModelOwner?: string;
    ModelLocation?: string;
    TotalParkingLots?: number;
    PictureUrl?: string;
    Tariff?: string;

    // Web properties
    Paths?: any[];
}

export class ParkingDTO {
    parkingID: number;
    title: string;
    subtitle: string | null;
}

export interface IParking {
    parkingID: number;
    parkingTypeID: number;
    title: string;
    subtitle: string;
    latitude: number;
    longitude: number;
    color: string;
    hasSensors: boolean;

    parkingPoints: IParkingPoint[];
    groupedParkingPoints: IParkingPoint[][];
}
